import styled from 'styled-components';

export const Container = styled.div`

`;

export const Content = styled.div`
	width: 260px;

	border: 1px solid #B6B6B6;
	border-radius: 16px;

	img{
		width: 100%;
		height: 190px;

		border-radius: 16px 16px 0 0;
	}

	.slick-prev:before,
    .slick-next:before {
      color: #212121;
    }

	.slick-prev, 
	.slick-next{
		background: #FFF;
		position: absolute;
	    top: 50%;
	    z-index:1;
	    border-radius: 50%;
	}

	.slick-next{
		right: 8px;
	}

	.slick-prev{
		left: 8px;
	}

	.slick-dots li button:before {
	   	color: #212121;
	}

	.slick-dots{
		bottom: 12px;
	}

	@media(max-width: 767px){
		width: 310px;

		.slick-dots li button:before {
		   	color: #FFF;
		}
	}

	@media(min-width: 1441px){
		width: 290px;

		img{
			height: 200px;
		}
	}
`;

export const PropertyInformationsContainer = styled.div`
	display: flex;
	align-items: flex-start;
	justify-content: center;

	flex-direction: column;

	padding: 8px 24px;

	>h2{
		font-size: 18px;
		color: #6EA5FF;
		font-weight: bold;
	}

	>p{
		margin: 12px 0 24px 0;

		font-size: 12px;
	}

	@media(max-width: 767px){
		>h2{
			margin-top: 12px;

			font-size: 21px;
		}

		>p{
			font-size: 14px;
		}
	}

	@media(min-width: 1441px){
		>h2{
			font-size: 20px;
		}
		
		>p{
			font-size: 14px;
		}
	}
`;

export const ButtonsContainer = styled.div`
	display: flex;
	align-items: center;
	justify-content: center;

	flex-direction: column;

	padding-bottom: 18px;

	>h3{
		font-size: 14px;
		color: #00BF33;
		font-weight: bold;

		margin-bottom: 16px;
	}

	>button{
		background: transparent;

		border: 1px solid #666666;

		width: 70%;
		padding: 12px 0;

		font-weight: 500;

		& + button{
			margin-top: 12px;
		}
	}

	@media(max-width: 767px){
		>h3{
			font-size: 14px;
		}

		>button{
			font-size: 12px;
		}
	}
`;